<template>
  <div @click="changeChecked" :class="{'box': true, 'checked': checkObj[computedKey]}">
    <div v-show="checkObj[computedKey]" class="checkd-red"></div>
    <i v-show="checkObj[computedKey]" class="el-icon-check checked-icon"></i>
    <slot name="template">没有需要选择的内容</slot>
  </div>
</template>

<script>
  export default {
    name: "consoleCheck",
    props: {
      checkObj: {
        type: Object
      },
      kv: {
        type: Object
      }
    },
    data() {
      return {
      }
    },
    methods: {
      changeChecked(){
        if(typeof this.computedValue === 'number'){
          if(this.checkObj[this.computedKey] === 0){
            this.checkObj[this.computedKey] = 1;
          }else{
            this.checkObj[this.computedKey] = 0;
          }
        }
        else if(typeof this.computedValue === 'boolean'){
          if(this.checkObj[this.computedKey] === false){
            this.checkObj[this.computedKey] = true;
          }else{
            this.checkObj[this.computedKey] = false;
          }
        }
      }
    },
    computed: {
      computedKey() {
        if (this.kv) {
          let keys = Object.keys(this.kv);
          if (keys.length > 0) {
            return keys[0];
          }
        }
        return 'checked';
      },
      computedValue(){
        if(this.kv){
          return this.kv[this.computedKey];
        }
        return false
      }
    }
  }
</script>

<style lang="less" scoped>
  .box {
    width: 100%;
    position: relative;
    display: inline-block;
    padding: 10px;
    border: 1px solid #c9c9c9;
    cursor: pointer;
    overflow: hidden;
    border-radius: 4px;
    &.checked {
      border-color: #ec1c1c;
    }
    .checkd-red {
      transform: rotate(45deg);
      position: absolute;
      z-index: 1;
      width: 50px;
      height: 50px;
      right: -25px;
      top: -25px;
      background-color: #ec1c1c;
    }
    .checked-icon {
      position: absolute;
      right: 4px;
      top: 4px;
      z-index: 2;
      color: #fff;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/console-check/index.vue